<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Users</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="addButton" (click)="onAddUserClick()">
                <ion-icon name="add"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" class="instructions">
        Users In Account:<br />
        Account Number: {{accountProfile.accountNumber}}<br />
        Dealership: {{dealership.dealershipName}}
    </ion-list-header>

    <ion-list>
        <ion-radio-group>
            @for (user of users; track $index) {
  <ion-item [disabled]="vb.disabled">
                <ion-label class="ion-text-wrap">
                    <span class="line1">{{user.firstName}} {{user.lastName}}</span><br />
                    <span class="line2">{{user.email}}</span><br />
                    <span class="line2">{{user.role}}</span>
                </ion-label>
                <ion-radio (click)="onUserClick(user)"></ion-radio>
            </ion-item>
}
        </ion-radio-group>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-button data-test="launchLocalhostButton" [disabled]="!selectedUser" color="primary" expand="full" (click)="onLoginClick('localhost')">
                        Launch localhost
                    </ion-button>
                </ion-col>
                <ion-col>
                    <ion-button data-test="launchStagingButton" [disabled]="!selectedUser" color="primary" expand="full" (click)="onLoginClick('staging')">
                        Launch staging.shuttlenomix.com
                    </ion-button>
                </ion-col>
                <ion-col>
                    <ion-button data-test="launchAppButton" [disabled]="!selectedUser" color="primary" expand="full" (click)="onLoginClick('app')">
                        Launch app.shuttlenomix.com
                    </ion-button>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    @if (debugMode) {
                    <ion-button data-test="chatbotSmokeTestButton" color="medium" expand="full" (click)="onChatbotSmokeTestClick()">
                        Chatbot Smoke Test
                    </ion-button>
                    }
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-toolbar>
</ion-footer>